module.exports = __webpack_public_path__ + "static/media/edit.61274c89.svg";